import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SecuredSessionStorageService } from '../../services/secure-session-storage/secure-session-storage.service';
import { LoginCredentialsInterface } from '@/app/login/interfaces/login-credentials.interface';

export const authGuard: CanActivateFn = (_route, _state) => {
  const router: Router = inject(Router);
  const securedSessionStorageService: SecuredSessionStorageService = inject(SecuredSessionStorageService);

  try {
    const raw = securedSessionStorageService.getSessionVariable('credentials');
    const credentials: LoginCredentialsInterface = raw ? JSON.parse(raw) : null;
    if (credentials?.username) {
      return true;
    }
  } catch {
    // sin sesión: no tumbar la app
  }

  router.navigate(['login']);
  return false;
};
